import { getGeoOverrideHeaders } from 'src/common/helpers/slices';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

import type { StripeCheckoutResponse, StripeSubscriptionPayload } from './use-stripe-subscription-checkout.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createStripeSubscriptionCheckout: builder.mutation<StripeCheckoutResponse, StripeSubscriptionPayload>({
      query: (payload) => ({
        method: 'POST',
        url: '/stripe-v2/subscription/checkout',
        body: payload,
        headers: getGeoOverrideHeaders(),
      }),

      transformResponse: (response: ApiResponse<StripeCheckoutResponse>) => {
        if (!response.data) {
          throw new Error('No data received from server');
        }

        return response.data;
      },
    }),
  }),
});

export const { useCreateStripeSubscriptionCheckoutMutation } = extendedApiSlice;
